import axios from "axios";

export default function initGravityForms() {
  if (!document.querySelector(".gform")) return;
  let phoneFields = document.querySelectorAll('input[type="tel"]');
  phoneFields.forEach((field) => addPhoneFormatter(field));

  let addressBlocks = document.querySelectorAll(".gform-field-address");
  addressBlocks.forEach((block) =>
    initAddressAutocomplete(block.querySelector("input"), block)
  );
  let submitBtn = document.querySelector(".gform .gform-submit");
  let form = document.querySelector(".gform");
  submitBtn.addEventListener("click", (event) => handleSubmit(event, form));
}

function handleSubmit(event, form) {
  event.preventDefault();
  let submitBody = {};
  let submitUrl = `${ajax.url}?action=submit_gravity_form&id=${form.dataset.formId}`;
  let errors = [];
  form.querySelectorAll(".gform-field-error").forEach((el) => {
    el.parentNode.removeChild(el);
  });
  console.log(form);
  Array.from(form.elements).forEach((el) => {
    validateField(el, errors);
    let id = el.id;
    let type = el.type;
    if (["checkbox", "radio", "submit"].includes(type) && !el.checked) return;

    //recaptcha naming schema
    let key =
      id === "g-recaptcha-response" ? id : `input_${id.replace(".", "_")}`;

    // GF API naming quirk for radios;
    if (type === "radio" && el.checked) {
      let key = `input_${el.name}`;
    }
    if (type === "file") {
      submitBody[key] = el.files[0]; //api only allows one submission
      // handleFileUpload(el.files[0]);
    } else {
      submitBody[key] = el.value;
    }
  });
  // if (errors.length > 0) return;

  // todo: change payload to multipart Form data.
  //New Form(form)...
  let formData = new FormData();
  for (let key in submitBody) {
    // debugger;
    formData.append(key, submitBody[key]);
  }
  for (let pair of formData.entries()) {
    console.log(pair[0] + ", " + pair[1]);
  }
  // https://localhost/wp-json/gf/v2/forms/1/submissions
  axios({
    method: "post",
    url: `${restUrl}gf/v2/forms/${+form.dataset.formid}/submissions`,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((res) => {
      if (res.data.is_valid)
        document.querySelector(".gform").innerHTML =
          res.data.confirmation_message;
    })
    .catch((err) => {
      console.error(err.data);
    });
}

function addPhoneFormatter(input, pattern = "standard") {
  if (pattern === "standard") {
    input.addEventListener("input", (e) => {
      let inputVal = e.target.value;
      let outputVal;
      const number = inputVal.replace(/[^\d]/g, "");
      const numberLength = number.length;
      console.log(number, numberLength);
      // we need to return the value with no formatting if its less than four digits
      // this is to avoid weird behavior that occurs if you  format the area code too early
      if (numberLength < 4) {
        outputVal = number;
      }

      // if phoneNumberLength is greater than 4 and less the 7 we start to return
      // the formatted number
      else if (numberLength < 7) {
        outputVal = `(${number.slice(0, 3)}) ${number.slice(3)}`;
      }

      // finally, if the phoneNumberLength is greater then seven, we add the last
      // bit of formatting and return it.
      else {
        outputVal = `(${number.slice(0, 3)}) ${number.slice(
          3,
          6
        )}-${number.slice(6, 10)}`;
      }

      e.target.value = outputVal;
    });
  }
}

function validateField(field, errorsArray) {
  // todo:  file validations;  after file submissions
  if (["submit"].includes(field.type)) return;

  //validate truthy broadly speaking
  if (field.hasAttribute("required") && !field.value) {
    createError(field);
    errorsArray.push(field);
    return;
  }

  // CAPTCHA
  if (field.classList.contains("g-recaptcha-response")) {
    validateCaptcha(field, errorsArray);
  }
  if (field.type === "file") {
    validateFileType(field, errorsArray);
  }

  if (field.type === "checkbox") {
    if (errorsArray.includes(field.parentNode)) return;
    validateCheckboxField(field, errorsArray);
  }
  if (field.type === "checkbox") {
    if (errorsArray.includes(field.parentNode)) return;
    validateRadioField(field, errorsArray);
  }

  //validate Phone format
  if (field.type === "tel") {
    validatePhoneField(field, errorsArray);
    return;
  }
  // EMAIL
  if (field.type === "email") {
    validateEmailField(field, errorsArray);
    return;
  }
}

function addCaptcha() {
  // debugger;
  let container = document.getElementById("gform-captcha");
  if (!container) return;
  let headScript = document.createElement("script");
  window.onloadCallback;
  headScript.innerHTML = `let gravityFormsCaptchaCallback = function() {
    let container = document.getElementById('gform-captcha');
    console.log('callback fxn running');
    console.log({container});
    grecaptcha.render('container', {'sitekey' : '${captchaKey}'});
  }; 
  window.gravityFormsCaptchaCallback  = gravityFormsCaptchaCallback`;
  document.querySelector("head").append(headScript);
  let bodyScript = document.createElement("script");
  // bodyScript.src =
  //   'https://www.google.com/recaptcha/api.js?onload=gravityFormsCaptchaCallback&render=explicit';
  // bodyScript.setAttribute('async', '');
  // bodyScript.setAttribute('defer', '');
  // document.querySelector('body').append(bodyScript);
}

function initAddressAutocomplete(field, addressFieldGroup) {
  let autocomplete = new google.maps.places.Autocomplete(field);

  autocomplete.addListener("place_changed", function () {
    let place = autocomplete.getPlace();
    console.log(place);

    let {
      streetNumber,
      route,
      city,
      state,
      country,
      county,
      postalCode,
      postalCodeSuffix,
    } = parseAddressComponents(place);

    if (streetNumber) {
      addressFieldGroup.querySelector(
        ".address-line1"
      ).value = `${streetNumber} ${route}`;
    }
    if (city) {
      addressFieldGroup.querySelector(".address-level2").value = city;
    }
    if (state) {
      addressFieldGroup.querySelector(".address-level1").value = state;
    }
    if (country) {
      addressFieldGroup.querySelector(".country-name").value = country;
    }
    if (postalCode) {
      addressFieldGroup.querySelector(".postal-code").value = postalCode;
    }
  });
}

function validateFileType(field, errorsArray) {
  if (!field.value) {
    return;
  }
  let validations = JSON.parse(field.dataset?.validation ?? {});
  let applicableValidations = removeEmptyObjValues(validations);
  let { required, maxFileSize, allowedExtensions } = applicableValidations;

  allowedExtensions = allowedExtensions.replace("-", " ").split(" ");

  let errorMessage = "";

  if (required) {
    if (!field.files[0]) {
      errorMessage += "This field is required";
    }
  }
  if (maxFileSize) {
    if (field.files[0].size > maxFileSize) {
      errorMessage += `This file is too large. The max is ${maxFileSize}`;
    }
  }
  if (allowedExtensions) {
    let type = field.files[0].type.replace("application/", "");
    if (!allowedExtensions.includes(type)) {
      errorMessage += `This file type is not supported.`;
    }
  }
  createError(field, errorMessage);
  errorsArray.push(field);
  console.log(field);
}

function removeEmptyObjValues(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

function createError(
  field,
  content = "This field is required.",
  upLevel = null
) {
  let error = document.createElement("small");
  error.classList.add("gform-field-error");
  error.textContent = content;
  if (upLevel == 2) {
    field.parentNode.parentNode.append(error);
  } else {
    field.parentNode.append(error);
  }
}
function validateCaptcha(field, errorsArray) {
  if (!grecaptcha.getResponse()) {
    createError(field, "Please verify that you're not a robot.");
    errorsArray.push(field);
  }
}
function validatePhoneField(field, errorsArray) {
  if (field.value && !field.value.length === 14) {
    createError(field, "Please enter a valid phone number.");
    errorsArray.push(field);
  }
}

function validateEmailField(field, errorsArray) {
  if (field.value && !field.value.includes("@") && !field.value.includes(".")) {
    createError(field, "Please enter a valid email.");
    errorsArray.push(field);
  }
}

function validateCheckboxField(field, errorsArray) {
  if (field.hasAttribute("required")) {
    let checkboxes = field.parentNode.querySelectorAll("input:checked");
    if (!checkboxes.length > 0) {
      createError(field, "Please select at least one option.", 2);
      errorsArray.push(field.parentNode);
    }
  }
}
function validateRadioField(field, errorsArray) {
  if (field.hasAttribute("required")) {
    let radios = field.parentNode.querySelectorAll("radio:checked");
    if (!radios.length > 0) {
      createError(field, "Please select at least one option.", 2);
      errorsArray.push(field.parentNode);
    }
  }
}

function parseAddressComponents({ address_components }) {
  let streetNumber,
    route,
    city,
    state,
    country,
    county,
    postalCode,
    postalCodeSuffix;

  address_components.forEach((component) => {
    if (component.types.includes("locality")) {
      city = component.long_name;
    } else if (component.types.includes("route")) {
      route = component.long_name;
    } else if (component.types.includes("street_number")) {
      streetNumber = component.long_name;
    } else if (component.types.includes("administrative_area_level_1")) {
      state = component.long_name;
    } else if (component.types.includes("country")) {
      country = component.long_name;
    } else if (component.types.includes("postal_code")) {
      postalCode = component.long_name;
    } else if (component.types.includes("postal_code_suffix")) {
      postalCodeSuffix = component.long_name;
    } else if (component.types.includes('"administrative_area_level_2"')) {
      county = component.long_name;
    }
  });
  return {
    streetNumber,
    route,
    city,
    state,
    country,
    county,
    postalCode,
    postalCodeSuffix,
  };
}
function renameCaptchaForGf(id) {}
